export default "__VITE_ASSET__8_SWZGbg__"